import type { IdentityCard, UserOverview } from '@wizbii/utils/models';

import { createReducer, on } from '@ngrx/store';
import { initSessionSuccess, updateIdentityCardSuccess } from '@stores/session/session-ngrx.action';

export const sessionKey = 'session';

export type SessionState = {
  user?: UserOverview;
  identityCard?: IdentityCard;
};

export const initialState: SessionState = { identityCard: undefined, user: undefined };

export const sessionReducer = createReducer(
  initialState,
  on(initSessionSuccess, (_, { userOverview, identityCard }) => {
    return { identityCard, user: userOverview };
  }),
  on(updateIdentityCardSuccess, (state, { identityCard }) => {
    return { ...state, identityCard };
  })
);
